export const defaultInvoiceFields = ["Name", "OrgNo", "GLN", "Telephone1", "Address1", "Address2", "Zip", "City", "CountryId", "Email"];
